import { Typography } from '@mui/material'
import { C1Alert, C1AlertTitle } from 'c1ui'
import * as isCidr from 'is-cidr'
import { isIPv4 } from 'is-ip'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { StringChipInput, StringChipInputProps } from './string'

type CIDRChipInputProps = Omit<StringChipInputProps, 'error' | 'helperText'> & {
    'aria-label'?: string
}

export const CIDRChipInput = ({ value, setValue, ...rest }: CIDRChipInputProps): React.ReactElement => {
    const [error, setError] = useState<boolean>(false)
    const [helperText, setHelperText] = useState<React.ReactNode>()

    return (
        <StringChipInput
            error={error}
            value={value}
            helperText={helperText}
            setValue={(values: string[]): void => {
                const nextValue: string[] = []
                let hadErrors = false
                values.forEach((v) => {
                    v = v.trim()
                    if (isCidr.v4(v)) {
                        nextValue.push(v)
                        return
                    }
                    if (isIPv4(v)) {
                        v = `${v}/32`
                        nextValue.push(v)
                        return
                    }
                    hadErrors = true
                    setHelperText(
                        <C1Alert severity="error">
                            <C1AlertTitle>
                                <FormattedMessage
                                    id="component_cidr_chip_input_error_title"
                                    defaultMessage="Invalid Input"
                                />
                            </C1AlertTitle>
                            <Typography>
                                <FormattedMessage
                                    id="component_cidr_chip_input_error_message"
                                    defaultMessage="Invalid input: '${input}', must be an IPv4 CIDR. (eg, 1.2.3.0/24)"
                                    values={{ input: v }}
                                />
                            </Typography>
                        </C1Alert>,
                    )
                    setError(true)
                })
                if (!hadErrors) {
                    setError(false)
                    setHelperText(undefined)
                }
                if (setValue) {
                    setValue(nextValue)
                }
            }}
            {...rest}
        />
    )
}
